import { TRIGGER_ACTIONS, TRIGGER_TYPES, type TriggerAction, type TriggerRestartFireMode, type TriggerType } from 'api/triggers/endpoints/types';

// Labels only. The VALUES come from the endpoint's canonical lists, so adding a
// member there is a compile error here until it is given a label — where the
// previous copy of these arrays would simply have gone missing from the dropdown.
export const TRIGGER_TYPE_LABELS: Record<TriggerType, string> = {
  node_status_change: 'Node status change',
};

const isTriggerType = (type: string): type is TriggerType => (TRIGGER_TYPES as readonly string[]).includes(type);

/**
 * A trigger's type in words. The wire `type` is a free VARCHAR rather than the
 * canonical list (see getTriggers), so an unknown one is shown as it is.
 */
export const triggerTypeLabel = (type: string): string => (isTriggerType(type) ? TRIGGER_TYPE_LABELS[type] : type);

export const TRIGGER_ACTION_LABELS: Record<TriggerAction, string> = {
  raise_event: 'Raise Event',
  submit_child: 'Submit Child Node',
};

const isTriggerAction = (action: string): action is TriggerAction => (TRIGGER_ACTIONS as readonly string[]).includes(action);

/** A status change's action in words. Like `type`, the stored `action` is not checked by the database, so an unknown one is shown as it is. */
export const triggerActionLabel = (action: string): string => (isTriggerAction(action) ? TRIGGER_ACTION_LABELS[action] : action);

export const RESTART_FIRE_MODE_LABELS: Record<TriggerRestartFireMode, string> = {
  all: 'All restarts',
  first: 'First restart only',
  last: 'Last restart only (retries exhausted)',
  first_and_last: 'First and last restart only',
};
